module.exports = __webpack_public_path__ + "media/images/pdf/logo-df17404745c831bbfae612689e4db355.png";